// extracted by mini-css-extract-plugin
export default {"lds-roller":"Spinner_lds-roller__YvEe1"};